import {ChangeDetectionStrategy, Component} from '@angular/core';
import {NotificationPage} from "../../notification/multi-page-notification/multi-page-notification.component";
import {
  NotificationDialogContentComponent
} from "../../notification/notification-dialog-content/notification-dialog-content.component";

@Component({
  selector: 'homey-referred-by-dialog',
  imports: [
    NotificationDialogContentComponent
  ],
  templateUrl: './referred-by-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReferredByDialogComponent extends NotificationPage<{ name: string }> {

}
